import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  main: {
    position: 'relative',
    padding: 10,
    marginBottom: 10,
    backgroundColor: '#141414',
    boxShadow: 'none',
  },
  addButton: {
    position: 'fixed',
    bottom: 30,
    right: 26,
  },
  webView: {
    background: theme.webView.background,
  },
}))

export default useStyles
